import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '~/actions';
import { Box, Icon } from '~/commonComponents';
import { Colors } from '~/themes/colors';
import { dashboardJobsService } from '../dashboardJobsService';
import { IDashboardJobsInfo } from '../dashboardJobsTypes';

export function useGetDashboardJobInfo() {
  const dispatch = useDispatch();

  const query = useQuery<IDashboardJobsInfo>({
    queryKey: ['dashboard-jobs-info'],
    queryFn: () => dashboardJobsService.getDashboardJobsInfo(),
    staleTime: 60 * 1000, // 1 minute
    gcTime: 60 * 1000, // 1 minute
    retry: 1,
  });

  useEffect(() => {
    if (query.data) {
      dispatch({
        type: 'SET_DASHBOARD_INFO',
        payload: {
          scheduled: query.data.filledCount,
          actionRequired: query.data.pendingCount,
          activeRequest: query.data.openCount,
          pendingReviewJobCount: query.data.pendingReviewJobCount,
          todayShift: query.data.todayShiftCount,
        },
      });
    }
  }, [query.data, dispatch]);

  useEffect(() => {
    if (query.isError) {
      dispatch({
        type: actions.SHOW_MESSAGE,
        payload: {
          popupProps: {
            Icon: () => (
              <Box marginBottom={20}>
                <Icon name="warning-outline" size={80} color={Colors.warning_500} />
              </Box>
            ),
            rightButtonText: 'Close',
          },
          title: 'Oops! Something Went Wrong',
          message: (
            <span>
              We weren’t able to load your Shifts Overview.
              <br />
              Please refresh the page to try again.
            </span>
          ),
        },
      });
    }
  }, [query.isError, dispatch]);

  return query;
}
